<template>
  <div>
    <div class="mx-5">
      <v-alert
        v-model="toAlert"
        type="warning"
        icon="mdi-alert-circle-outline"
        dense
      >
        <p class="text-subtitle-2">
          This module is currently in beta testing phase. Access is limited to
          selected users only.
        </p>
      </v-alert>
    </div>
    <v-row class="space-y-10">
      <v-col cols="12" md="8" class="pa-0">
        <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
          <v-tab v-for="tab in tabList" :key="tab.id" @click="changeTab(tab)">{{
            tab.name
          }}</v-tab>
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="4" class="d-flex justify-space-between">
        <v-text-field
          v-model="search"
          outlined
          dense
          hide-details
          prepend-inner-icon="search"
          label="Search"
          class="search-input mr-3"
        />
        <v-btn
          class="btn-save"
          :color="$vuetify.theme.themes.light.submitBtns"
          v-if="tab == 1"
          @click="add()"
        >
          Add IPCR
        </v-btn>
      </v-col>
    </v-row>
    <v-card class="dt-container" elevation="0" outlined>
      <v-data-table
        :headers="tab == 2 ? headers2 : headers"
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
        class="text-body-2"
      >
        <template v-slot:[`item.approvals`]="{ item }">
          <div v-if="item.isFaculty == 0" class="pa-4">
            <div
              class="mx-auto"
              :class="
                $vuetify.breakpoint.xl
                  ? 'xl_lg_width'
                  : $vuetify.breakpoint.lg
                  ? 'xl_lg_width'
                  : $vuetify.breakpoint.md
                  ? 'md_width'
                  : 'sm_width'
              "
            >
              <!-- TARGETS -->
              <v-row no-gutters align="center" class="mb-1">
                <v-col cols="4">
                  <span class="font-weight-bold">TARGETS:</span>
                </v-col>
                <v-col cols="8" class="text-right">
                  <v-chip
                    x-small
                    class="pa-2"
                    :class="getTargetsStatus(item.targets_rating).fontColor"
                    :color="getTargetsStatus(item.targets_rating).chip"
                  >
                    {{ getTargetsStatus(item.targets_rating).sts }}
                  </v-chip>
                </v-col>
              </v-row>

              <!-- MPOR -->
              <v-row no-gutters align="center" class="mb-0">
                <v-col cols="4">
                  <span class="font-weight-bold">MPOR:</span>
                </v-col>

                <v-col cols="8">
                  <v-row
                    v-for="(i, idx) in getMPORStatus(item.mpor)"
                    :key="idx"
                    no-gutters
                    align="center"
                    class="mb-1"
                  >
                    <v-col cols="6"> {{ i.month }}: </v-col>

                    <v-col cols="6" class="text-right">
                      <v-chip
                        x-small
                        class="pa-2"
                        :class="i.fontColor"
                        :color="i.chip"
                      >
                        {{ i.sts }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- SUMMARY -->
              <v-row no-gutters align="center" class="mb-1">
                <v-col cols="4">
                  <span class="font-weight-bold">SUMMARY:</span>
                </v-col>

                <v-col cols="8" class="text-right">
                  <v-chip
                    x-small
                    class="pa-2"
                    :class="getSummaryStatus(item.summary).fontColor"
                    :color="getSummaryStatus(item.summary).chip"
                  >
                    {{ getSummaryStatus(item.summary).sts }}
                  </v-chip>
                </v-col>
              </v-row>

              <!-- IPCR -->
              <v-row no-gutters align="right">
                <v-col cols="4">
                  <span class="font-weight-bold">IPCR:</span>
                </v-col>

                <v-col cols="8">
                  <v-row no-gutters align="center" class="mb-1">
                    <v-col cols="6"> Assessed: </v-col>

                    <v-col cols="6" class="text-right">
                      <v-chip
                        x-small
                        class="pa-2"
                        :class="
                          getStatus('assess', item) == 'For Submission' ||
                          getStatus('assess', item) == 'For Approval'
                            ? ''
                            : 'white--text'
                        "
                        :color="
                          getStatus('assess', item) == 'For Submission' ||
                          getStatus('assess', item) == 'For Approval'
                            ? ''
                            : getStatus('assess', item) == 'Approved'
                            ? 'green'
                            : 'red'
                        "
                      >
                        {{ getStatus("assess", item) }}
                      </v-chip>
                    </v-col>
                  </v-row>

                  <v-row no-gutters align="center">
                    <v-col cols="6"> Final Rater: </v-col>

                    <v-col cols="6" class="text-right">
                      <v-chip
                        x-small
                        class="pa-2"
                        :class="
                          getStatus('final_rating', item) == 'For Submission' ||
                          getStatus('final_rating', item) == 'For Approval'
                            ? ''
                            : 'white--text'
                        "
                        :color="
                          getStatus('final_rating', item) == 'For Submission' ||
                          getStatus('final_rating', item) == 'For Approval'
                            ? ''
                            : getStatus('final_rating', item) == 'Approved'
                            ? 'green'
                            : 'red'
                        "
                      >
                        {{ getStatus("final_rating", item) }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
          <div v-if="item.isFaculty == 1" class="pa-4">
            <div class="d-flex justify-center">
              <div
                class="d-flex justify-space-between"
                :class="
                  $vuetify.breakpoint.xl
                    ? 'xl_lg_width'
                    : $vuetify.breakpoint.lg
                    ? 'md_width'
                    : $vuetify.breakpoint.md
                    ? 'md_width'
                    : 'sm_width'
                "
              >
                <div class="text-body font-weight-bold">TARGETS:</div>
                <div class="ml-2">
                  <v-chip
                    x-small
                    class="pa-1"
                    :class="getTargetsStatus(item.targets_rating).fontColor"
                    :color="getTargetsStatus(item.targets_rating).chip"
                  >
                    {{ getTargetsStatus(item.targets_rating).sts }}
                  </v-chip>
                </div>
              </div>
            </div>
            <div v-if="true">
              <div class="my-2 d-flex justify-center">
                <div
                  class="d-flex justify-space-between"
                  :class="
                    $vuetify.breakpoint.xl
                      ? 'xl_lg_width'
                      : $vuetify.breakpoint.lg
                      ? 'md_width'
                      : $vuetify.breakpoint.md
                      ? 'md_width'
                      : 'sm_width'
                  "
                >
                  <div class="text-body font-weight-bold">IPCR RATING:</div>
                  <div class="ml-2">
                    <v-chip
                      x-small
                      class="pa-1"
                      :class="getTargetsStatus(item.faculty_rating).fontColor"
                      :color="getTargetsStatus(item.faculty_rating).chip"
                    >
                      {{ getTargetsStatus(item.faculty_rating).sts }}
                    </v-chip>
                  </div>
                </div>
              </div>
              <div class="my-2 d-flex justify-center">
                <div
                  class="d-flex justify-space-between"
                  :class="
                    $vuetify.breakpoint.xl
                      ? 'xl_lg_width'
                      : $vuetify.breakpoint.lg
                      ? 'md_width'
                      : $vuetify.breakpoint.md
                      ? 'md_width'
                      : 'sm_width'
                  "
                >
                  <div class="text-body font-weight-bold">IPCR:</div>
                  <div class="ml-2">
                    <div class="d-flex justify-space-between">
                      <div>Assessed:</div>

                      <v-chip
                        x-small
                        class="pa-1"
                        :class="
                          getStatus('assess', item) == 'For Submission' ||
                          getStatus('assess', item) == 'For Approval'
                            ? ''
                            : 'white--text'
                        "
                        :color="
                          getStatus('assess', item) == 'For Submission' ||
                          getStatus('assess', item) == 'For Approval'
                            ? ''
                            : getStatus('assess', item) == 'Approved'
                            ? 'green'
                            : 'red'
                        "
                      >
                        {{ getStatus("assess", item) }}
                      </v-chip>
                    </div>
                    <div class="d-flex justify-space-between">
                      <div>Final Rater:</div>
                      <v-chip
                        x-small
                        class="pa-1"
                        :class="
                          getStatus('final_rating', item) == 'For Submission' ||
                          getStatus('final_rating', item) == 'For Approval'
                            ? ''
                            : 'white--text'
                        "
                        :color="
                          getStatus('final_rating', item) == 'For Submission' ||
                          getStatus('final_rating', item) == 'For Approval'
                            ? ''
                            : getStatus('final_rating', item) == 'Approved'
                            ? 'green'
                            : 'red'
                        "
                      >
                        {{ getStatus("final_rating", item) }}
                      </v-chip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div class="button-group my-2">
            <v-btn class="global-btn-save" @click="viewItem(item)">
              Targets
            </v-btn>
            <v-btn
              v-if="!item.isFaculty && showActionButton"
              class="global-btn-save"
              @click="viewMPOR(item)"
            >
              MPOR</v-btn
            >
            <v-btn
              v-if="item.isFaculty && showActionButton"
              class="global-btn-save"
              @click="viewFacultyIpcrRating(item)"
            >
              IPCR RATING</v-btn
            >

            <v-btn
              class="global-btn-save"
              v-if="showActionButton"
              @click="viewSupport(item)"
              >Support Function</v-btn
            >
            <v-btn
              v-if="!item.isFaculty && showActionButton"
              class="global-btn-save"
              @click="viewMPORSummary(item)"
            >
              Summary</v-btn
            >
            <v-btn
              v-if="!item.isFaculty"
              class="global-btn-save"
              @click="viewIPCR(item)"
              >IPCR Report</v-btn
            >

            <v-btn
              v-if="item.isFaculty"
              class="global-btn-save"
              @click="viewFacultyIPCR(item)"
              >IPCR Report</v-btn
            >
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mt-4" align="center">
      <v-col cols="12" md="4" class="d-flex align-center">
        <span class="pagination-label mr-2">Show</span>

        <v-select
          dense
          outlined
          hide-details
          :value="options.itemsPerPage"
          :items="perPageChoices"
          class="per-page-select"
          @change="options.itemsPerPage = parseInt($event, 10)"
        />

        <span class="pagination-label ml-2">entries</span>
      </v-col>

      <v-col cols="12" md="4" class="text-center pagination-info">
        Showing
        <strong>{{ paginationData.pageStart + 1 }}</strong>
        -
        <strong>{{ paginationData.pageStop }}</strong>
        of
        <strong>{{ paginationData.itemsLength }}</strong>
        entries
      </v-col>

      <v-col cols="12" md="4" class="d-flex justify-end">
        <v-pagination
          v-model="options.page"
          :length="paginationData.pageCount"
          :total-visible="5"
          color="#147452"
          class="modern-pagination"
        />
      </v-col>
    </v-row>

    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()"> Close </v-btn>
          <v-btn color="green" class="white--text" @click="confirmDelete()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <PerformanceEvaluationDialog :data="itemData" :action="action" />
    <ViewIPCRFunctionDialog :data="ipcrData" :action="action" />
    <MPORDialog :data="mporData" />
    <MPORSummaryDialog :data="mporSumData" />
    <IPCRSupportDialog :data="supportData" />
    <IPCRFacultyRatingDialog :data="facultyIpcrData" />
    <ViewIPCRDialog :data="ipcr" />
    <ViewFacultyIPCRDialog :data="faculty_ipcr" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="5000"
    ></fade-away-message-component>
  </div>
</template>
<script>
import axios from "axios";
export default {
  components: {
    PerformanceEvaluationDialog: () =>
      import("../../components/Dialogs/Forms/PerformanceEvaluationDialog.vue"),
    ViewIPCRFunctionDialog: () =>
      import("../Dialogs/Views/ViewIPCRFunctionDialog.vue"),
    MPORSummaryDialog: () =>
      import("../../components/Dialogs/Forms/MPORSummaryDialog.vue"),
    MPORDialog: () => import("../../components/Dialogs/Forms/MPORDialog.vue"),
    IPCRSupportDialog: () =>
      import("../../components/Dialogs/Forms/IPCRSupportDialog.vue"),
    IPCRFacultyRatingDialog: () =>
      import(
        "../../components/Dialogs/Forms/IPCRFaculty/IPCRFacultyRatingDialog.vue"
      ),

    ViewFacultyIPCRDialog: () =>
      import("../Dialogs/Views/ViewFacultyIPCRDialog.vue"),
    ViewIPCRDialog: () =>
      import("../../components/Dialogs/Views/ViewIPCRDialog.vue"),
  },
  data: () => ({
    toAlert: false,
    showActionButton: true,
    confirmDialog: false,
    itemToDelete: null,
    search: "",
    fullname: null,
    applicantData: null,
    itemData: null,
    taggingData: null,
    ipcrData: null,
    supportData: null,
    headers: [
      {
        text: "Year",
        value: "year",
        width: 100,
        align: "start",
        valign: "center",
        sortable: false,
      },
      {
        text: "Period",
        value: "period",
        width: 200,
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Approvals",
        value: "approvals",
        align: "center",
        valign: "center",
        sortable: false,
      },
      //  {
      //   text: "Assess",
      //   value: "assesed_by_status",
      //   align: "center",
      //   valign: "center",
      //   sortable: false,
      // },
      // {
      //   text: "Final Rater",
      //   value: "final_rating_by_status",
      //   align: "center",
      //   valign: "center",
      //   sortable: false,
      // },
      {
        text: "Action",
        value: "action",
        align: "center",
        width: 100,
        valign: "center",
        sortable: false,
      },
    ],

    data: [],
    periodList: [
      {
        id: 1,
        description: "January to June",
      },
      {
        id: 2,
        description: "July to December",
      },
      {
        id: 3,
        description: "January to December",
      },
    ],

    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    activeTab: { id: 1, name: "Active-Jobs" },
    tab: 1,
    tabList: [
      //   { id: 1, name: "Target" },
      //   { id: 2, name: "Tagged Employees" },
      //   { id: 3, name: "Applicants" },
    ],
    mporData: null,
    ipcr: null,
    faculty_ipcr: null,
    mporSumData: null,
    facultyIpcrData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    yearList: [],
    ipcrCancelSource: null,
  }),

  mounted() {
    this.eventHub.$on("closeViewIPCRFunctionDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closePerformanceEvaluationDialog", () => {
      this.initialize();
    });

    this.eventHub.$on("closeMPORDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeMPORSummaryDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeIPCRSupportDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewIPCRDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeIPCRFacultyRatingDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewFacultyIPCRDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closePerformanceEvaluationDialog");
    this.eventHub.$off("closeViewIPCRFunctionDialog");
    this.eventHub.$off("closeMPORDialog");
    this.eventHub.$off("closeMPORSummaryDialog");
    this.eventHub.$off("closeIPCRSupportDialog");
    this.eventHub.$off("closeViewIPCRDialog");
    this.eventHub.$off("closeIPCRFacultyRatingDialog");
    this.eventHub.$off("closeViewFacultyIPCRDialog");
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    filterYear: {
      handler(newData, oldData) {
        if (oldData != newData) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  computed: {
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },

    isBetaTester() {
      let arr = [
        "86",
        "631",
        "417",
        "287",
        "50",
        "215",
        "306",
        "652",
        "215",
        "67",
      ];
      return arr.includes(this.$store.state.user.id);
    },
  },
  methods: {
    getPeriodDescription(id) {
      for (let i = 0; i < this.periodList.length; i++) {
        if (this.periodList[i].id == id) {
          return this.periodList[i].description;
        }
      }
    },
    pagination(data) {
      this.paginationData = data;
    },

    initialize() {
      // if (this.isBetaTester) {
      if (this.ipcrCancelSource) {
        this.ipcrCancelSource.cancel("New request superseded this one");
      }
      this.ipcrCancelSource = axios.CancelToken.source();

      this.axiosCall(
        "/ipcr/getMyIPCR",
        "GET",
        null,
        true,
        this.ipcrCancelSource.token,
      )
        .then((res) => {
          if (res) {
            // console.log("IP", res.data);
            this.data = res.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            // expected — newer request took over
            return;
          }
          console.error(err);
          this.loading = false;
        });
      // }
    },

    getStatus(type, item) {
      let toReturn = "";
      if (type == "assess") {
        if (item.isSubmitted == 0) {
          toReturn = "For Submission";
        } else {
          if (item.assesed_by_status == 1) {
            toReturn = "For Approval";
          } else if (item.assesed_by_status == 2) {
            toReturn = "Approved";
          } else if (item.assesed_by_status == 3) {
            toReturn = "Pending";
          }
        }
      } else if (type == "final_rating") {
        if (item.isSubmitted == 0) {
          toReturn = "For Submission";
        } else {
          if (item.final_rating_by_status == null) {
            toReturn = "For Submission";
          } else if (item.final_rating_by_status == 1) {
            toReturn = "For Approval";
          } else if (item.final_rating_by_status == 2) {
            toReturn = "Approved";
          } else if (item.final_rating_by_status == 3) {
            toReturn = "Pending";
          }
        }
      }
      return toReturn;
    },

    changeTab(tab) {
      this.activeTab = tab;

      // if (tab.id == 1) {

      this.tab = tab.id;
      this.initialize();
      // } else if (tab.id == 2) {
      //   this.getVerifiedUsers();
      //   this.tab = tab.id;
      // }
    },
    add() {
      this.itemData = { id: null };
      this.action = "Add";
    },

    viewMPOR(item) {
      if (
        item.targetCount > 0 &&
        item.targets_rating.isSubmitted == 1 &&
        item.targets_rating.assesed_by_status == 2
      ) {
        this.mporData = item;
      } else {
        let msg = "";
        if (item.targetCount == 0) {
          msg = "No Targets Found! Please add your targets first.";
        } else {
          if (item.targets_rating.isSubmitted == 0) {
            msg = "Please submit your Targets first for approval.";
          } else {
            if (
              item.targets_rating.isSubmitted == 1 &&
              item.targets_rating.assesed_by_status != 2
            ) {
              msg =
                "Your targets are not yet approved. Please contact your immediate head for approval.";
            }
          }
        }
        console.log("MPOR", item);
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = msg;
      }

      // this.action = "Update";
    },
    viewMPORSummary(item) {
      this.mporSumData = item;
    },

    viewFacultyIpcrRating(item) {
      if (
        item.targetCount > 0 &&
        item.targets_rating.isSubmitted == 1 &&
        item.targets_rating.assesed_by_status == 2
      ) {
        this.facultyIpcrData = item;
      } else {
        let msg = "";
        if (item.targetCount == 0) {
          msg = "No Targets Found! Please add your targets first.";
        } else {
          if (item.targets_rating.isSubmitted == 1) {
            if (item.targets_rating.assesed_by_status == 1) {
              msg =
                "Your targets is still FOR APPROVAL. Please contact your immediate head for approval.";
            } else if (item.targets_rating.assesed_by_status == 3) {
              msg =
                "Your targets is on PENDING. Please workout the remarks and resubmit for approval.";
            }
          } else {
            msg = "Please submit your Targets first for APPROVAL.";
          }
        }
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = msg;
      }
    },

    viewIPCR(item) {
      this.ipcr = item;
      console.log(item);
    },

    viewFacultyIPCR(item) {
      console.log("VIEW FACULTY IPCR", item);
      this.faculty_ipcr = item;
    },
    viewItem(item) {
      this.ipcrData = item;
      // this.action = "Update";
    },

    viewSupport(item) {
      this.supportData = item;
    },

    getMPORStatus(list) {
      const mL = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        let chip;
        let sts;
        let fontColor;
        if (list[i].isSubmitted == 0) {
          chip = "";
          fontColor = "";
          sts = "For Submission";
        } else {
          if (list[i].head_approval_status == 3) {
            fontColor = "white--text";
            sts = "Pending";
            chip = "red";
          } else if (list[i].head_approval_status == 2) {
            chip = "green";
            fontColor = "white--text";
            sts = "Approved";
          } else {
            fontColor = "";
            chip = "";
            sts =
              list[i].head_approval_status == 1
                ? "For Approval"
                : "For Submission";
          }
        }
        arr.push({
          month: mL[list[i].month - 1],
          status: list[i].head_approval_status,
          chip,
          fontColor,
          sts,
          isSubmitted: list[i].isSubmitted,
        });
      }
      return arr;
    },

    getTargetsStatus(item) {
      let chip = null;
      let sts = null;
      let fontColor = null;
      if (item) {
        if (item.isSubmitted == 0) {
          chip = "";
          fontColor = "";
          sts = "For Submission";
        } else {
          if (item.assesed_by_status == 3) {
            fontColor = "white--text";
            sts = "Pending";
            chip = "red";
          } else if (item.assesed_by_status == 2) {
            chip = "green";
            fontColor = "white--text";
            sts = "Approved";
          } else {
            fontColor = "";
            chip = "";
            sts =
              item.assesed_by_status == 1 ? "For Approval" : "For Submission";
          }
        }
        return {
          status: item.assesed_by_status,
          chip,
          fontColor,
          sts,
          isSubmitted: item.isSubmitted,
        };
      }
      return {
        status: "For Submission",
        chip,
        fontColor,
        sts,
        isSubmitted: 0,
      };
    },

    // getFacultyRatingStatus(item) {
    //   console.log("FACULTY SDASD", item);
    //   let chip;
    //   let sts;
    //   let fontColor;
    //   if (item.isSubmitted == 0) {
    //     chip = "";
    //     fontColor = "";
    //     sts = "For Submission";
    //   } else {
    //     if (item.assesed_by_status == 3) {
    //       fontColor = "white--text";
    //       sts = "Pending";
    //       chip = "red";
    //     } else if (item.assesed_by_status == 2) {
    //       chip = "green";
    //       fontColor = "white--text";
    //       sts = "Approved";
    //     } else {
    //       fontColor = "";
    //       chip = "";
    //       sts = item.assesed_by_status == 1 ? "For Approval" : "For Submission";
    //     }
    //   }
    //   return {
    //     status: item.assesed_by_status,
    //     chip,
    //     fontColor,
    //     sts,
    //     isSubmitted: item.isSubmitted,
    //   };
    // },

    getSummaryStatus(item) {
      let chip;
      let sts;
      let fontColor;
      if (item.isSubmitted == 0) {
        chip = "";
        fontColor = "";
        sts = "For Submission";
      } else {
        if (item.assesed_by_status == 3) {
          fontColor = "white--text";
          sts = "Pending";
          chip = "red";
        } else if (item.assesed_by_status == 2) {
          chip = "green";
          fontColor = "white--text";
          sts = "Approved";
        } else {
          fontColor = "";
          chip = "";
          sts = item.assesed_by_status == 1 ? "For Approval" : "For Submission";
        }
      }
      return {
        status: item.assesed_by_status,
        chip,
        fontColor,
        sts,
        isSubmitted: item.isSubmitted,
      };
    },

    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    confirmDelete() {
      this.axiosCall("/ipcr/" + this.itemToDelete.id, "DELETE").then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },
  },
};
</script>

<style scoped>
.xl_lg_width {
  width: 30%;
}
.md_width {
  width: 75%;
}
.sm_width {
  width: 100%;
}
</style>
